<template>
  <v-app>
    <v-app-bar app flat class="white">
      <FullHeaderComponent />
    </v-app-bar>
    <v-main class="grey lighten-4 mt-5">
      <div class="container1400">
        <v-container fluid>
          <h1 class="text-h4 font-weight-medium mt-5 mb-5">
            {{ $t("ReviewTrip") }}
          </h1>
          <v-alert dense outlined type="error" v-if="error">
            <ul>
              <li v-for="item in error" :key="item.msg">
                {{ $t(item.msg) }}
              </li>
            </ul>
          </v-alert>
          <v-row v-if="data">
            <v-col cols="12" md="6">
              <v-card elevation="0" class="pt-6 pb-15">
                <v-row class="pa-5">
                  <v-col cols="12" md="5">
                    <v-carousel
                      hide-delimiters
                      class
                      height="150"
                      v-if="data.item.pictures"
                    >
                      <v-carousel-item
                        v-for="(items, i) in data.item.pictures"
                        :key="i"
                        :src="
                          $store.state.baseUrl +
                            'listing/thumb320x240-' +
                            items.file_name
                        "
                      ></v-carousel-item>
                    </v-carousel>
                  </v-col>
                  <v-col cols="12" md="7">
                    <div class="pb-3">
                      {{ $t(data.item.type) }} - {{ $t(data.item.category) }}
                    </div>
                    <div class="text-h5">{{ data.item.name }}</div>
                    <div class="mt-2">
                      {{ data.item.no_rooms }} - {{ $tc("Room", 2) }},
                      {{ data.item.no_bathrooms }} - {{ $tc("Bathroom", 2) }}
                    </div>
                  </v-col>
                </v-row>
                <v-row class="pa-5 pt-0 pb-0">
                  <v-col cols="12" md="4">
                    <div class="subtitle-2">{{ $t("Checkin") }} :</div>
                    <div class="mt-2">
                      {{
                        formatDate(
                          $store.state.reserveQuery.dates[0] + "T00:00"
                        )
                      }}
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="subtitle-2">{{ $t("CheckOut") }} :</div>
                    <div class="mt-2">
                      {{
                        formatDate(
                          $store.state.reserveQuery.dates[1] + "T00:00"
                        )
                      }}
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="subtitle-2">{{ $t("Nights") }} :</div>
                    <div class="mt-2">
                      {{ data.days }}
                    </div>
                  </v-col>
                </v-row>
                <div class="text-h5 pa-5">{{ $t("Pricedetails") }}</div>
                <v-simple-table
                  class="ml-5 mr-5 grey lighten-4"
                  v-if="bookingData.payment_type == 'full_pay'"
                >
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <td>
                          {{ $t("BookingAmount") }}
                        </td>
                        <td class="font-weight-bold text-right">
                          {{ data.dataInMemberCurrency.currency_code }}
                          {{ data.dataInMemberCurrency.fullPayData.amount }}
                        </td>
                      </tr>
                      <tr v-if="data.security">
                        <td>
                          {{ $t("Securitydeposit") }}
                        </td>
                        <td class="font-weight-bold text-right">
                          {{ data.dataInMemberCurrency.currency_code }}
                          {{ data.dataInMemberCurrency.securityAmount }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <v-tooltip right color="light-blue">
                            <template v-slot:activator="{ on, attrs }">
                              <span
                                v-bind="attrs"
                                v-on="on"
                                class="text-decoration-underline"
                                >{{ $t("Fees") }}</span
                              >
                            </template>
                            <div class="caption">
                              <div>
                                {{ $t("BA2") }}:
                                {{ data.dataInMemberCurrency.currency_code }}
                                {{ data.dataInMemberCurrency.membership_fee }}
                              </div>
                              <div>
                                {{ $t("BookingFee") }}:
                                {{ data.dataInMemberCurrency.currency_code }}
                                {{
                                  data.dataInMemberCurrency.fullPayData
                                    .nomad_fee
                                }}
                              </div>
                              <div>
                                {{ $t("CleaningFee") }}:
                                {{ data.dataInMemberCurrency.currency_code }}
                                {{
                                  data.dataInMemberCurrency.fullPayData
                                    .cleaning_fee
                                }}
                              </div>
                            </div>
                          </v-tooltip>
                        </td>
                        <td class="font-weight-bold text-right">
                          {{ data.dataInMemberCurrency.currency_code }}
                          {{
                            (
                              parseFloat(
                                data.dataInMemberCurrency.membership_fee
                              ) +
                              parseFloat(
                                data.dataInMemberCurrency.fullPayData.nomad_fee
                              ) +
                              parseFloat(
                                data.dataInMemberCurrency.fullPayData
                                  .cleaning_fee
                              )
                            ).toFixed(2)
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold">
                          {{ $t("Amountpayableis") }}
                        </td>
                        <td class="font-weight-bold text-right">
                          {{ data.dataInMemberCurrency.currency_code }}
                          {{
                            (
                              parseFloat(
                                data.dataInMemberCurrency.securityAmount
                              ) +
                              parseFloat(
                                data.dataInMemberCurrency.fullPayData.amount
                              ) +
                              parseFloat(
                                data.dataInMemberCurrency.membership_fee
                              ) +
                              parseFloat(
                                data.dataInMemberCurrency.fullPayData.nomad_fee
                              ) +
                              parseFloat(
                                data.dataInMemberCurrency.fullPayData
                                  .cleaning_fee
                              )
                            ).toFixed(2)
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <v-simple-table
                  v-if="bookingData.payment_type != 'full_pay'"
                  class="ml-5 mr-5 grey lighten-4"
                >
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <td>
                          {{ $t("BookingAmount") }}
                        </td>
                        <td class="font-weight-bold text-right">
                          {{ data.dataInMemberCurrency.currency_code }}
                          {{ data.dataInMemberCurrency.actualPrice }}
                        </td>
                      </tr>
                      <tr v-if="data.security">
                        <td>
                          {{ $t("Securitydeposit") }}
                        </td>
                        <td class="font-weight-bold text-right">
                          {{ data.dataInMemberCurrency.currency_code }}
                          {{ data.dataInMemberCurrency.securityAmount }}
                        </td>
                      </tr>
                      <tr v-for="(item, i) in payData" :key="i">
                        <td v-if="item.payment_number == 1">
                          {{ $t("Initialpayment") }}
                        </td>
                        <td v-else>
                          {{ $t("PaymentDue") }} -
                          {{ formatDate(item.dateDue) }}
                        </td>
                        <td class="font-weight-bold text-right">
                          {{ data.dataInMemberCurrency.currency_code }}
                          {{ item.amountInMC }} +
                          <v-tooltip right color="light-blue">
                            <template v-slot:activator="{ on, attrs }">
                              <span
                                v-bind="attrs"
                                v-on="on"
                                class="text-decoration-underline"
                                >{{
                                  (
                                    parseFloat(item.nomad_feeInMC) +
                                    parseFloat(item.cleaning_fee)
                                  ).toFixed(2)
                                }}({{ $t("Fees") }})</span
                              >
                            </template>
                            <div class="caption">
                              <div>
                                {{ $t("BookingFee") }}:
                                {{ data.dataInMemberCurrency.currency_code }}
                                {{ item.nomad_feeInMC }}
                              </div>
                              <div>
                                {{ $t("CleaningFee") }}:
                                {{ data.dataInMemberCurrency.currency_code }}
                                {{ item.cleaning_fee }}
                              </div>
                            </div>
                          </v-tooltip>
                        </td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold">
                          {{ $t("Amountpayablenow") }}
                        </td>
                        <td class="font-weight-bold text-right">
                          {{ data.dataInMemberCurrency.currency_code }}
                          {{
                            (
                              parseFloat(
                                data.dataInMemberCurrency.securityAmount
                              ) +
                              parseFloat(payData[0].nomad_feeInMC) +
                              parseFloat(payData[0].cleaning_fee) +
                              parseFloat(payData[0].amountInMC)
                            ).toFixed(2)
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card>
            </v-col>
            <v-col cols="12" md="6">
              <v-card elevation="0">
                <v-form
                  ref="form"
                  v-model="valid"
                  @submit.prevent="next"
                  lazy-validation
                  class="pa-5 pt-5"
                >
                  <v-radio-group
                    v-if="data.days >= 28"
                    v-model="bookingData.payment_type"
                    @change="changePayment"
                  >
                    <v-radio
                      value="full_pay"
                      :rules="reqRules"
                      v-bind:label="$t('full_pay')"
                    >
                    </v-radio>
                    <v-radio
                      v-if="data.halfPay"
                      value="half_pay"
                      :rules="reqRules"
                      v-bind:label="$t('half_pay')"
                    >
                    </v-radio>
                    <v-radio
                      v-if="data.partPay"
                      value="part_pay"
                      :rules="reqRules"
                      v-bind:label="$t('part_pay')"
                    >
                    </v-radio>
                  </v-radio-group>
                  <div class="text-h5 pt-5 pb-5">{{ $t("RW") }}</div>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-select
                        hide-details="auto"
                        v-model="bookingData.check_in_time"
                        :items="data.item.check_in_times"
                        :rules="reqRules"
                        :label="$t('SelectCheckInTime')"
                        outlined
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-select
                        hide-details="auto"
                        v-model="bookingData.check_out_time"
                        :items="data.item.check_out_times"
                        :rules="reqRules"
                        :label="$t('SelectCheckOutTime')"
                        outlined
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-select
                        hide-details="auto"
                        :label="$tc('Adult', 2)"
                        v-model="bookingData.no_adults"
                        :items="noGuests"
                        :rules="reqRules"
                        outlined
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="6" v-if="noChildrens.length">
                      <v-select
                        hide-details="auto"
                        :label="$tc('Children', 2)"
                        v-model="bookingData.no_childrens"
                        :items="noChildrens"
                        outlined
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row v-if="data.item.contract">
                    <v-col cols="12">
                      <div class="subtitle-2 mb-2">{{ $t("RE") }} :</div>
                      <v-card
                        elevation="0"
                        class="grey lighten-5"
                        max-width="100%"
                      >
                        <v-card-title class="subtitle-1 grey lighten-4">
                          {{ data.item.contract.title }}
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text
                          style="max-height: 400px; overflow-y: scroll"
                        >
                          <div
                            class="body-2 mt-2"
                            v-html="data.item.contract.description"
                          >
                            {{ data.item.contract.description }}
                          </div>
                          <v-divider></v-divider>
                          <div class="body-2 mt-2">
                            <v-row
                              v-for="item in data.item.contract.terms"
                              :key="item._id"
                            >
                              <v-col>
                                <v-checkbox
                                  :rules="termsRules"
                                  v-model="bookingData.acceptedTerms"
                                  :label="item.title"
                                  :value="item"
                                ></v-checkbox>
                                <div class="subtitle-2 mt-2">
                                  {{ $t("Estimatedpenalty") }}:
                                  {{ data.currency_code }}
                                  {{ item.penalty }}
                                </div>
                                <div
                                  class="body-2 mt-2"
                                  v-html="item.description"
                                ></div>
                                <v-divider></v-divider>
                              </v-col>
                            </v-row>
                          </div>
                        </v-card-text>
                        <v-card-actions class="grey lighten-4">
                          <div
                            v-if="
                              bookingData.acceptedTerms.length !=
                                data.item.contract.terms.length
                            "
                            class="body-2 pa-2 red--text"
                          >
                            {{ $t("AcceptAllTerms") }}
                          </div>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-btn
                        large
                        color="light-blue white--text"
                        min-width="200px"
                        rounded
                        type="submit"
                      >
                        <span class="mr-2">{{ $t("Continue") }}</span>
                        <v-icon size="small">mdi-arrow-right-thick</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-main>
    <v-footer app>
      <CopyrightComponent />
      <WaitDialogComponent :waitDialog="waitDialog" />
    </v-footer>
  </v-app>
</template>

<script>
import timeoutMixin from "@/mixins/timeoutMixin.js";
import FullHeaderComponent from "@/components/layout/FullHeaderComponent.vue";
import CopyrightComponent from "@/components/layout/CopyrightComponent.vue";
import WaitDialogComponent from "@/components/layout/WaitDialogComponent.vue";
import BookingService from "@/services/BookingService";
import { format } from "date-fns";

export default {
  name: "ReviewBooking",
  mixins: [timeoutMixin],
  components: {
    FullHeaderComponent,
    CopyrightComponent,
    WaitDialogComponent
  },
  data() {
    return {
      format,
      data: "",
      bookingData: {
        property_id: this.$store.state.reserveQuery.property_id,
        payment_type: "full_pay",
        dates: this.$store.state.reserveQuery.dates,
        acceptedTerms: []
      },
      error: null,
      valid: null,
      waitDialog: false,
      reqRules: [value => !!value || this.$t("string719")],
      currencyCode: this.$store.state.user.prefered_currency,
      noGuests: [],
      noChildrens: [0],
      payData: []
    };
  },
  computed: {
    termsRules() {
      return [
        this.bookingData.acceptedTerms.length ==
          this.data.item.contract.terms.length || this.$t("string719")
      ];
    }
  },
  created: async function() {
    BookingService.reviewBooking({
      dates: this.$store.state.reserveQuery.dates,
      property_id: this.$store.state.reserveQuery.property_id
    })
      .then(result => {
        this.data = result.data;
        this.bookingData.property_user_id = result.data.item.user_id;
        this.noGuests = Array.from(
          { length: result.data.item.no_guests },
          (_, i) => i + 1
        );
        this.noChildrens = Array.from(
          { length: result.data.item.no_childrens },
          (_, i) => i + 1
        );
        this.noChildrens.unshift(0);
        this.bookingData.contractTitle = this.data.item.contract.title;
        this.bookingData.contractDes = this.data.item.contract.description;
      })
      .catch(err => {
        this.error = err.response.data.error;
      });
  },
  methods: {
    changePayment() {
      if (this.bookingData.payment_type == "half_pay") {
        this.payData = this.data.halfPayData;
      } else if (this.bookingData.payment_type == "part_pay") {
        this.payData = this.data.partPayData;
      }
    },
    formatDate(val) {
      return this.format(new Date(val), "eee, do MMM, yyyy");
    },
    async next() {
      await this.$refs.form.validate();
      if (this.valid) {
        this.waitDialog = true;
        BookingService.addBooking(this.bookingData)
          .then(result => {
            this.waitDialog = false;
            this.$router.push({
              name: "CompleteBooking",
              params: { id: result.data._id }
            });
          })
          .catch(err => {
            this.error = err.response.data.errors;
            this.waitDialog = false;
          });
      }
    }
  }
};
</script>

<style></style>
